module.exports = "/static/assets/70a73e9b3fadba285a6d68db9a91cbb3.png";